



















































































import Vue from 'vue'
import PostListItem from './PostListItem.vue'
import { CategoryTreeNodeType } from '../../models/CategoryTreeNode'

export default Vue.extend({
  name: 'CategoryPostTree',
  components: {
    PostListItem
  },
  props: {
    categoryTree: {
      type: Array
    },
    completedPosts: {
      type: Set,
      default: () => new Set()
    },
    completedCategories: {
      type: Set,
      default: () => new Set()
    },
    level: {
      type: Number,
      default: 0
    },
    available: {
      type: Boolean,
      default: true
    },
    isBackground: {
      type: Boolean,
      default: true
    },
    productId: {
      type: String
    },
    categoryLockData: {
      type: Array
    }
  },
  computed: {
    device(): string {
      return this.$store.getters.device
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    },
    isBuilder(): boolean {
      return this.$route.query.builder === 'true'
    }
  },
  methods: {
    nodeIsPost(type: CategoryTreeNodeType) {
      return type === CategoryTreeNodeType.Post
    },
    isLocked(categoryId: string) {
      if (!this.categoryLockData) {
        return false
      }
      const lockData = this.categoryLockData.find(
        c => c.categoryId === categoryId
      )
      if (lockData) {
        return lockData.isLocked
      }
      return false
    }
  }
})
